export class PaymentCalculatorService {

  public static calculatePayment(interestRate: number, financedAmount: number, paymentPeriodsPerYear: number, term: number) : number {

    const rate = interestRate / 100 / paymentPeriodsPerYear
    const paymentPeriods = term / 12 * paymentPeriodsPerYear
    const payment = rate === 0 ? financedAmount / paymentPeriods : financedAmount * (rate + (rate / (Math.pow(1 + rate, paymentPeriods) - 1)))

    return payment

  }

  public static getPaymentPeriods(periodString: string) : number {
    let periodNumber : number = 52    // Default will be weekly 

    switch(periodString) {
      case 'Weekly':
        periodNumber = 52
        break
      case 'Bi-weekly':
        periodNumber = 26
        break
      case 'Monthly':
        periodNumber = 12
        break
    }

    return periodNumber
  }
  
}